/* import __COLOCATED_TEMPLATE__ from './list.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class List extends Component {
  @tracked customAuthenticationTokens = this.args.customAuthenticationTokens;
}
